import React from 'react'

import { Space, Heading4, Join } from '@gousto-internal/citrus-react'

import type { Recipe } from '@library/menu-service'
import type { MenuRecipe } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { LoadingSkeleton } from 'routes/Menu/components/Detail/LoadingSkeleton'

import { RecipeAttributesPills } from './RecipeAttributesPills'

type RecipeAttributesProps = {
  shelfLife: Recipe['shelfLife']
  dietaryClaims?: Recipe['dietaryClaims']
  fiveADay?: Recipe['fiveADay']
  equipments?: MenuRecipe['equipment']
  proteinPerPortionMg?: number
  isHeatOnly?: boolean
  loading: boolean
}

export const RecipeAttributes = ({
  dietaryClaims,
  equipments,
  shelfLife,
  fiveADay,
  proteinPerPortionMg,
  isHeatOnly,
  loading,
}: RecipeAttributesProps) => (
  <Join with={<Space size={2} />}>
    <Heading4>Recipe details</Heading4>
    <RecipeAttributesPills
      dietaryClaims={dietaryClaims}
      equipments={equipments}
      shelfLife={shelfLife}
      fiveADay={fiveADay}
      proteinPerPortionMg={proteinPerPortionMg}
      isHeatOnly={isHeatOnly}
      loading={loading}
    />
    {loading && (
      <>
        <LoadingSkeleton style={{ height: '10px', width: '50%', marginBottom: '15px' }} />
        <LoadingSkeleton style={{ height: '10px', width: '55%' }} />
      </>
    )}
  </Join>
)
